import { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import AuthActions from "store/auth/actions";

const { logout } = AuthActions;

const AutoLogout = props => {
  useEffect(() => {
    props.logout();
  }, [props]);

  return null;
};

export default compose(connect(null, { logout }))(AutoLogout);
